"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTGeneric = void 0;
const js_base64_1 = require("js-base64");
class JWTGeneric {
    constructor(signer, decoder) {
        this.signer = signer;
        this.decoder = decoder;
        this.header = { typ: 'JWT', alg: 'ETH' };
        /**
         * Set payload to be signed
         * @param payload
         */
        this.setPayload = (payload) => {
            this.payload = payload;
            return {
                sign: this.sign.bind(this),
                setHeader: this.setHeader.bind(this)
            };
        };
        /**
         * Set payload to be signed
         * @param payload
         */
        this.setHeader = (payload) => __awaiter(this, void 0, void 0, function* () {
            this.header = payload;
            return {
                sign: yield this.sign.bind(this),
                setPayload: this.setPayload.bind(this)
            };
        });
        this.arePropertiesValid = (payload) => {
            if (payload.exp) {
                const isExpired = new Date(payload.exp).getTime() < Date.now();
                if (isExpired) {
                    return false;
                }
            }
            if (payload.nbf) {
                const isBefore = new Date(payload.nbf).getTime() > Date.now();
                if (isBefore) {
                    return false;
                }
            }
            if (payload.iat) {
                const isBefore = new Date(payload.iat).getTime() > Date.now();
                if (isBefore) {
                    return false;
                }
            }
            return true;
        };
    }
    /**
     * Set token to be verified or decoded
     * @param encodedToken
     */
    setToken(encodedToken) {
        this.encodedToken = encodedToken;
        return {
            decode: this.decode.bind(this),
            verify: this.verify.bind(this)
        };
    }
    static base64Stringified(data) {
        return js_base64_1.Base64.encode(JSON.stringify(data));
    }
    static fromBase64JSONParse(data) {
        return JSON.parse(js_base64_1.Base64.fromBase64(data));
    }
    sign() {
        return __awaiter(this, void 0, void 0, function* () {
            const header = JWTGeneric.base64Stringified(this.header);
            const payload = JWTGeneric.base64Stringified(this.payload);
            const signature = yield this.signature();
            return `${header}.${payload}.${signature}`;
        });
    }
    /**
     * Verify if signature was signed by pubKey and return true/false
     * @param pubKey
     */
    verify(pubKey) {
        const { header, signature, payload } = this.decode();
        const joinedHeaderPayload = JWTGeneric.base64Stringified(header) + '.' + JWTGeneric.base64Stringified(payload);
        const decode = this.decoder(joinedHeaderPayload, signature);
        const arePropertyValid = this.arePropertiesValid(payload);
        if (!arePropertyValid) {
            return false;
        }
        return pubKey.toLowerCase() === decode.toLowerCase();
    }
    decode() {
        const [header, payload, signature] = this.encodedToken.split('.');
        return {
            header: JWTGeneric.fromBase64JSONParse(header),
            payload: JWTGeneric.fromBase64JSONParse(payload),
            signature: signature
        };
    }
    signature() {
        return this.signer(JWTGeneric.base64Stringified(this.header) + '.' + JWTGeneric.base64Stringified(this.payload));
    }
}
exports.JWTGeneric = JWTGeneric;
//# sourceMappingURL=JWTGeneric.js.map